import heroScenes from '@/components/redesign/heroScenes';
import guideAppImages from '@/components/evRedesign/guideAppImages';
const hero = heroScenes.map(scene => scene.src);
const siteImagery = {
  hero,
  existingCharger: 'https://zaptec.objects.frb.io/assets/New-brand-imagery-2025/New-imagery-Zaptec-Go/Zaptec_Go_Home_Charging_1168.jpg',
  newCharger: 'https://nexblue.com/cdn/shop/files/photo.png?v=1756629540&width=1600',
  chargingDetail: 'https://zaptec.objects.frb.io/assets/New-brand-imagery-2025/New-imagery-Zaptec-Go/Zaptec_Go_Home_Charging_2291.webp',
  installation: 'https://zaptec.objects.frb.io/assets/Zaptec-Go-2/Zaptec_Go2_Home_Charging_1157.webp',
  appScreen: guideAppImages[0].src,
  connectionConcept: 'https://media.base44.com/images/public/691da83d30e4689f56b0df07/3629715d7_generated_image.png',
  savings: 'https://media.base44.com/images/public/691da83d30e4689f56b0df07/623024371_ChatGPTImageJun5202612_23_29PM.png',
};
export default siteImagery;